export const useSupportNeedGlossaryStore = defineStore('support-need-glossary', () => {
  const isOpen = ref(false)

  return { isOpen }
})
